export enum InfoSpotPurposeEnum {
  NULL = 'NULL',
  POSTER = 'POSTER',
  MAP = 'MAP',
  INSTRUCTION = 'INSTRUCTION',
  NEIGHBORHOOD_MAP = 'NEIGHBORHOOD_MAP',
  ANNOUNCEMENT = 'ANNOUNCEMENT',
  OTHER = 'OTHER',
}
